<template>
	<Modal @close="$emit('close')" :draggable="false">
		<template slot="title">Pallet Label</template>
		<template slot="body">
			<div style="width:460px; height:470px;">
				<table class="view_tbl" border="0">
					<colgroup>
						<col style="width: 90px;" />
						<col style="width: 120px;" />
						<col style="width: 90px;" />
						<col style="width: 120px;" />
					</colgroup>
					<tbody>
						<tr>
							<th colspan="4" class="al_center"><h4 class="inner_h5">Forwarder</h4></th>
						</tr>
						<tr>
							<th>Name</th>
							<td colspan="3">
								<input type="text" class="tbl_int" v-model.trim="forwarder_name" />
							</td>
						</tr>
						<tr>
							<th>Address</th>
							<td colspan="3">
								<textarea rows="3" class="textarea_type mgb_10" v-model.trim="forwarder_address"></textarea>
							</td>
						</tr>
						<tr>
							<th colspan="4" class="al_center"><h4 class="inner_h5">Ship to</h4></th>
						</tr>
						<tr>
							<th>Name</th>
							<td colspan="3">
								<input type="text" class="tbl_int" v-model.trim="ship_to_name" />
							</td>
						</tr>
						<tr>
							<th>Address</th>
							<td colspan="3">
								<textarea rows="3" class="textarea_type" v-model.trim="ship_address"></textarea>
							</td>
						</tr>
						<tr>
							<th>Telephone</th>
							<td colspan="3">
								<input type="text" class="tbl_int" v-model.trim="ship_telephone" />
							</td>
						</tr>
						<tr>
							<td colspan="4" class="al_right"><a href="javascript:void(0);" class="gray_bt mgb_10" @click="getShipment()">S/O Ship.Info.</a></td>
						</tr>
						<tr>
							<th colspan="4" class="al_center"><h4 class="inner_h5">Options</h4></th>
						</tr>
						<tr>
							<th></th>
							<td colspan="3">
								<label class="mgr_10"><input type="radio" value="DOMESTIC" v-model="international_type" />DOMESTIC</label>
								<label class="mgr_15"><input type="radio" value="OVERSEA" v-model="international_type" />OVERSEA</label>
								<label class="fl_r">
									<input type="checkbox" v-model="is_final_destination" />
									<span>Final Destination</span>
								</label>
							</td>
						</tr>
						<tr>
							<th>Remark</th>
							<td colspan="3">
								<input type="text" class="tbl_int" v-model.trim="remark" placeholder="Please, Write briefly." />
							</td>
						</tr>
						<tr>
							<th>
								Number of<br />
								Pallets
							</th>
							<td>
								<currency-input type="text" style="width: 100%;" :disabled="!not_for_box" :precision="0" v-model.trim="number_of_pallets" class="tbl_int ssm_int al_right" placeholder="Not for Box Only" />
							</td>
							<th>
								Number of<br />
								Prints per Sheet
							</th>
							<td>
								<currency-input type="text" style="width: 100%;" :disabled="!not_for_box" :precision="0" v-model.trim="prints_per_sheet" class="tbl_int ssm_int al_right" placeholder="Not for Box Only" />
							</td>
						</tr>
						<tr>
							<td colspan="4">
								<label class="fl_r">
									<input type="checkbox" v-model="not_for_box" @change="setNotForBoxOnly()" />
									<span>Not for Box</span>
								</label>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="popup_bottom">
				<a href="javascript:void(0);" class="search_bt fl_l" @click="saveInvoicePalletLabel()">Save</a>
				<a href="javascript:void(0);" class="search_bt mgr_5" @click="printPalletLabel()">Print</a>
				<a href="javascript:void(0);" class="gray_bt" @click="$emit('close')">Close</a>
			</div>
		</template>
	</Modal>
</template>

<script>
import { apiSelectInvoicePalletLabel, apiSaveInvoicePalletLabel } from '@/api/sales/boxing.js';
import { apiSelectInvoiceShipmentOnly } from '@/api/sales/invoice.js';
import { apiGetReportTemplate, Report, reportMrtUrl, PrintType } from '@/api/util';
import Modal from '@/components/common/Modal';
export default {
	data: () => ({
		ship_to_name: '',
		ship_country: '',
		ship_address: '',
		ship_telephone: '',

		forwarder_name: '',
		forwarder_address: '',
		remark: '',
		number_of_pallets: null,
		prints_per_sheet: null,
		not_for_box: false,
		international_type: 'DOMESTIC',
		is_final_destination: false,

		invoice: {},
		company: {},
	}),
	components: {
		Modal,
	},
	props: {
		invoice_no: {
			type: Number,
		},
	},
	computed: {
		user() {
			return this.$session.get('user');
		},
		company_id() {
			return this.user ? this.user.company_id : null;
		},
	},
	methods: {
		setNotForBoxOnly() {
			this.prints_per_sheet = this.not_for_box ? 4 : null;
			if (!this.not_for_box) this.number_of_pallets = null;
		},
		async saveInvoicePalletLabel() {
			if (!this.checkValidation()) return;

			const param = {
				invoice_no: this.invoice_no,
				forwarder_name: this.forwarder_name,
				forwarder_address: this.forwarder_address,
				ship_to_name: this.ship_to_name,
				ship_address: this.ship_address,
				ship_telephone: this.ship_telephone,
				not_for_box: this.not_for_box,
				number_of_pallets: this.number_of_pallets,
				prints_per_sheet: this.prints_per_sheet,
				remark: this.remark,
			};

			const { data } = await apiSaveInvoicePalletLabel(param);
			if (data > -1) {
				this.$toast.success('Saved Successfully');
				this.$emit('close');
			}
		},
		checkValidation() {
			if (this.not_for_box) {
				if (!this.number_of_pallets) {
					this.$toast.error('Please, Input the Number of Pallets.');
					return false;
				} else if (!this.prints_per_sheet) {
					this.$toast.error('Please, Input the Number of Prints per Sheet.');
					return false;
				}
			} else {
				if (!this.invoice.box_count) {
					this.$toast.error('Please, Make Box First.');
					return false;
				}
			}

			return true;
		},
		getCountArr(box_count, prints_per_sheet, not_for_box) {
			const arr = [];
			for (let i = 0; i < box_count; i++) {
				const el = (i + 1).toString();
				let j = 0;
				do {
					j++;
					arr.push(el);
				} while (not_for_box && j < prints_per_sheet);
			}

			return arr;
		},
		async printPalletLabel() {
			if (!this.checkValidation()) return;

			const file_name = 'PalletLabel';
			const box_count = this.not_for_box ? this.number_of_pallets : this.invoice.box_count;
			const count_arr = this.getCountArr(box_count, this.prints_per_sheet, this.not_for_box);
			//const is_us = ['US', 'USA'].includes(this.ship_country);
			const print_data = {
				not_for_box: this.not_for_box,
				//international_type: is_us ? 'DOMESTIC' : 'OVERSEA',
				ship_to_code: this.invoice.ship_to_code,
				so_dn: this.invoice.so_dn,
				company: this.company,
				forwarder: {
					name: this.forwarder_name,
					address: this.forwarder_address,
				},
				shipment: {
					name: this.ship_to_name,
					address: this.ship_address,
					telephone: this.ship_telephone,
				},
				box_count: box_count,
				count_arr: count_arr,
				remark: this.remark,
				today: this.$moment(new Date()).format('MM-DD-YYYY HH:mm:ss'),

				international_type: this.international_type,
				is_final_destination: this.is_final_destination,
			};

			const reportTemplate = await apiGetReportTemplate(file_name, reportMrtUrl(file_name));
			console.log(print_data);
			const report = new Report(reportTemplate, print_data, file_name, PrintType.Normal);
			this.$store.commit('setReport', report);
		},
		async getShipment() {
			const { data } = await apiSelectInvoiceShipmentOnly({ invoice_no: this.invoice_no });

			this.ship_to_name = data.ship_to_name;
			this.ship_address = data.address_detail + '\n' + data.address_city + ', ' + data.address_state + ' ' + data.address_zipcode;
			this.ship_country = data.address_country;
			this.ship_telephone = data.telephone;
		},
		async selectInvoicePalletLabel() {
			const { data } = await apiSelectInvoicePalletLabel(this.invoice_no);

			this.invoice = {
				so_dn: data.so_dn,
				ship_to_code: data.ship_to_code,
				box_count: data.box_count,
			};

			if (!data.ship_country || data.ship_country == 'US' || data.ship_country == 'USA') this.international_type = 'DOMESTIC';
			else this.international_type = 'OVERSEA';

			if (this.company_id === 'newjigu') {
				this.company = {
					name: data.company_name,
					address_detail: '225 UNDERHILL BLVD DOOR#101',
					address_city: 'SYOSSET',
					address_state: 'NY',
					address_zipcode: '11791',
					phone_no: data.company_phone_no,
				};
			} else {
				this.company = {
					name: data.company_name,
					address_detail: data.company_address_detail,
					address_city: data.company_address_city,
					address_state: data.company_address_state,
					address_zipcode: data.company_address_zipcode,
					phone_no: data.company_phone_no,
				};
			}

			this.forwarder_name = data.forwarder_name;
			this.forwarder_address = data.forwarder_address;

			this.ship_to_name = data.ship_to_name;
			this.ship_address = data.ship_address;
			this.ship_telephone = data.ship_telephone;
			this.ship_country = data.ship_country;

			this.not_for_box = data.not_for_box;
			this.number_of_pallets = data.number_of_pallets;
			this.prints_per_sheet = data.prints_per_sheet;
			this.remark = data.remark;
		},
		keyInput(ev) {
			if (ev.keyCode == 27) this.$emit('close');
		},
	},
	created() {
		this.selectInvoicePalletLabel();
	},
	mounted() {
		var vm = this;
		window.addEventListener('keydown', function(ev) {
			vm.keyInput(ev);
			ev.stopPropagation();
		});
	},
};
</script>

<style></style>
